import { useState, useCallback } from "react";
import {
	getImpersonatedEmail,
	setImpersonatedEmail,
	clearImpersonatedEmail,
} from "@infra/implementations/storage/impersonationStore";
import type { ImpersonationContextValue } from "./ImpersonationContext.types";

export function useImpersonationContextViewModel(): ImpersonationContextValue {
	const [impersonatedEmail, setImpersonatedEmailState] = useState<string | null>(() => getImpersonatedEmail());

	const startImpersonation = useCallback((email: string) => {
		setImpersonatedEmail(email);
		setImpersonatedEmailState(email);
	}, []);

	const stopImpersonation = useCallback(() => {
		clearImpersonatedEmail();
		setImpersonatedEmailState(null);
	}, []);

	return {
		impersonatedEmail,
		isImpersonating: impersonatedEmail !== null,
		startImpersonation,
		stopImpersonation,
	};
}
